import Context from "shared/util/Context";

import * as Web from "apps/photo_overlay/util/web";
import { ERRORS } from "apps/photo_overlay/util/constants";


// Initial state
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	isOpen: false,
	isLoading: false,
	error: null,
	userid: null,
	albumId: null,
	index: null,
	images: [],
	imageCache: {},
};


// Action types
// ----------------------------------------------------------------------------

export const OPEN = "PHOTO_OVERLAY.OPEN";
export const CLOSE = "PHOTO_OVERLAY.CLOSE";
export const SET_IMAGES = "PHOTO_OVERLAY.SET_IMAGES";
export const SET_INDEX = "PHOTO_OVERLAY.SET_INDEX";
export const NEXT = "PHOTO_OVERLAY.NEXT";
export const PREVIOUS = "PHOTO_OVERLAY.PREVIOUS";
export const LOAD_IMAGES = "PHOTO_OVERLAY.LOAD_IMAGES";
export const LOAD_IMAGES_SUCCESS = "PHOTO_OVERLAY.LOAD_IMAGES_SUCCESS";
export const LOAD_IMAGES_FAILURE = "PHOTO_OVERLAY.LOAD_IMAGES_FAILURE";


// Reducer
// ----------------------------------------------------------------------------

export function reducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case OPEN: {
			return {
				...state,
				isOpen: true,
				userid: action.payload.userid,
				albumId: action.payload.albumId,
				index: action.payload.index || 0,
				showPhotoUploadModal: action.payload.showPhotoUploadModal,
			};
		}

		case CLOSE: {
			return {
				...state,
				isOpen: false,
				userid: null,
				albumId: null,
				images: [],
				index: null,
			};
		}

		case SET_IMAGES: {
			return {
				...state,
				images: action.payload.images,
				imageCache: {
					...state.imageCache,
					[action.payload.userid]: {
						...state.imageCache[action.payload.userid],
						[action.payload.albumId]: action.payload.images,
					},
				},
			};
		}

		case SET_INDEX: {
			return {
				...state,
				index: action.payload.index,
			};
		}

		case NEXT: {
			if (!state.images || !state.images.length) {
				return state;
			}

			return {
				...state,
				index: state.index === (state.images.length - 1)
					? 0
					: state.index + 1,
			};
		}

		case PREVIOUS: {
			if (!state.images || !state.images.length) {
				return state;
			}

			return {
				...state,
				index: state.index === 0
					? state.images.length - 1
					: state.index - 1,
			};
		}

		case LOAD_IMAGES: {
			return {
				...state,
				isLoading: true,
			};
		}

		case LOAD_IMAGES_SUCCESS: {
			return {
				...state,
				isLoading: false,
			};
		}

		case LOAD_IMAGES_FAILURE: {
			return {
				...state,
				isLoading: false,
				error: action.payload.message,
			};
		}

		default: {
			return state;
		}
	}
}


// Actions
// ----------------------------------------------------------------------------

export const setImages = ({ userid, albumId, images }) => {
	return {
		type: SET_IMAGES,
		payload: {
			userid,
			albumId,
			images,
		},
	};
};

export const open = ({ userid, albumId, index, images } = {}) => {
	return (dispatch) => {
		if (!userid) {
			return console.error("PhotoOverlay.open must be called with an userid");
		}

		// extended check since albumId can be `0`
		if (albumId === null || typeof albumId === "undefined") {
			return console.error("PhotoOverlay.open must be called with an album id");
		}

		dispatch({
			type: OPEN,
			payload: {
				userid,
				albumId,
				index,
				showPhotoUploadModal: Context.has("NO_PHOTOS"),
			},
		});

		if (images) {
			dispatch(setImages({ userid, albumId, images }));
		}

		return true;
	};
};

export const close = () => {
	return { type: CLOSE };
};

export const setIndex = (index) => {
	return {
		type: SET_INDEX,
		payload: {
			index,
		},
	};
};

export const next = () => {
	return { type: NEXT };
};

export const previous = () => {
	return { type: PREVIOUS };
};

export const loadImages = ({ userid, albumId }) => {
	return (dispatch) => {
		dispatch({ type: LOAD_IMAGES });

		Web.loadImages({ userid, albumId })
			.then((res) => {
				dispatch({ type: LOAD_IMAGES_SUCCESS });
				dispatch({
					type: SET_IMAGES,
					payload: {
						userid,
						albumId,
						images: res.photos ? res.photos : res,
					},
				});
			})
			.catch((err) => {
				let message = ERRORS.DEFAULT;

				if (
					err &&
					err.error &&
					err.error.type &&
					ERRORS[err.error.type]
				) {
					message = ERRORS[err.error.type];
				}

				dispatch({
					type: LOAD_IMAGES_FAILURE,
					error: true,
					payload: {
						message,
					},
				});
			});
	};
};



// WEBPACK FOOTER //
// ./src/ducks/photo_overlay.js